/**
 * DSA form - klient: prefill z referera (data-atrybuty na wrapperze),
 * conditional field (dsaCopyrightBasis pokazywany dla "naruszenie praw autorskich"),
 * licznik znaków dla dsaDescription.
 *
 * Walidacja wszystkich powyższych mechanizmów dubluje się serwerowo
 * w klasie Dsa_Cf7_Integration - to jest warstwa UX.
 */

function initDsaForm() {
    const root = document.querySelector('.dsaform__wrapper');
    if (!root) return;

    const form = root.querySelector('form.wpcf7-form') || root;

    // 1) Prefill z data-atrybutów
    const urlInput   = form.querySelector('input[name="dsaUrl"]');
    const titleInput = form.querySelector('input[name="dsaTitle"]');
    if (urlInput && root.dataset.prefillUrl && !urlInput.value) {
        urlInput.value = root.dataset.prefillUrl;
        urlInput.dispatchEvent(new Event('input', { bubbles: true }));
        urlInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
    if (titleInput && root.dataset.prefillTitle && !titleInput.value) {
        titleInput.value = root.dataset.prefillTitle;
        titleInput.dispatchEvent(new Event('input', { bubbles: true }));
        titleInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    // 2) Conditional field: dsaCopyrightBasis
    const violationSelect  = form.querySelector('select[name="dsaViolationType"]');
    const copyrightWrapper = form.querySelector('.dsaform__copyrightBasis');
    const updateConditional = () => {
        if (!violationSelect || !copyrightWrapper) return;
        const trigger = (copyrightWrapper.dataset.showWhen || '').split('=')[1] || 'naruszenie praw autorskich';
        const show = violationSelect.value === trigger;
        copyrightWrapper.style.display = show ? '' : 'none';
        // Selector łapie zarówno stary radio jak i nowy checkbox exclusive
        // (CF7 radio jest domyślnie required nawet bez * - dlatego pole
        // zostało przełączone na checkbox exclusive żeby było opcjonalne).
        copyrightWrapper.querySelectorAll('input[name^="dsaCopyrightBasis"]').forEach((r) => {
            r.disabled = !show;
            if (!show) r.checked = false;
        });
    };
    if (violationSelect && copyrightWrapper) {
        violationSelect.addEventListener('change', updateConditional);
        updateConditional();
    }

    // 3) Licznik znaków dla dsaDescription
    const desc = form.querySelector('textarea[name="dsaDescription"]');
    if (desc) {
        const counter = document.createElement('div');
        counter.className = 'dsaform__counter';
        const wrapper = desc.closest('.dsaform__field') || desc.parentNode;
        wrapper.appendChild(counter);
        const updateCounter = () => {
            const n = desc.value.length;
            counter.textContent = n + ' / 200';
            counter.classList.toggle('dsaform__counter--ok', n >= 200);
        };
        desc.addEventListener('input', updateCounter);
        updateCounter();
    }
}

document.addEventListener('DOMContentLoaded', initDsaForm);

export {};
